export type Theme = "default" | "modern" | "elegant" | "vibrant" | "minimal"

export interface ThemeConfig {
    name: string
    label: string
    description: string
    colors: {
        background: string
        foreground: string
        primary: string
        secondary: string
        accent: string
        muted: string
        border: string
    }
    fonts: {
        heading: string
        body: string
    }
    radius: string
}

export const themes: Record<Theme, ThemeConfig> = {
    default: {
        name: "default",
        label: "Clássico",
        description: "Light and functional with the hotel orange identity",
        colors: {
            background: "0 0% 100%",
            foreground: "20 14% 8%",
            primary: "28 100% 50%", // Hotel Orange (#FF7A00)
            secondary: "30 40% 96%",
            accent: "46 83% 57%", // Hotel Gold
            muted: "30 20% 96%",
            border: "28 20% 88%",
        },
        fonts: {
            heading: "var(--font-sans)",
            body: "var(--font-sans)",
        },
        radius: "0.75rem",
    },
    modern: {
        name: "modern",
        label: "Modern Dark",
        description: "The default sophisticated dark theme",
        colors: {
            background: "240 10% 3.9%",
            foreground: "0 0% 98%",
            primary: "47.9 95.8% 53.1%", // #FFA500 (Hotel Orange-ish)
            secondary: "240 3.7% 15.9%",
            accent: "12 76% 61%",
            muted: "240 3.7% 15.9%",
            border: "240 3.7% 15.9%",
        },
        fonts: {
            heading: "var(--font-heading)", // Inter/Default
            body: "var(--font-sans)",
        },
        radius: "0.5rem",
    },
    elegant: {
        name: "elegant",
        label: "Elegant Gold",
        description: "Sophisticated with serif fonts and gold accents",
        colors: {
            background: "20 14% 4%", // Very dark warm grey/brown
            foreground: "30 20% 90%", // Creamy white
            primary: "46 83% 57%", // Gold
            secondary: "24 10% 15%",
            accent: "46 83% 57%",
            muted: "24 10% 15%",
            border: "46 20% 20%",
        },
        fonts: {
            heading: "serif", // Will need to load a serif font
            body: "sans-serif",
        },
        radius: "0rem", // Sharp corners for elegance
    },
    vibrant: {
        name: "vibrant",
        label: "Vibrant Pop",
        description: "Colorful, high energy and rounded",
        colors: {
            background: "0 0% 100%", // White
            foreground: "240 10% 3.9%",
            primary: "262 83% 58%", // Purple/Pink
            secondary: "190 90% 50%", // Cyan
            accent: "340 82% 52%", // Pink
            muted: "240 4.8% 95.9%",
            border: "240 5.9% 90%",
        },
        fonts: {
            heading: "sans-serif",
            body: "sans-serif",
        },
        radius: "1.5rem", // Very rounded
    },
    minimal: {
        name: "minimal",
        label: "Clean Minimal",
        description: "Stark black and white, high contrast",
        colors: {
            background: "0 0% 100%",
            foreground: "0 0% 0%",
            primary: "0 0% 0%",
            secondary: "0 0% 90%",
            accent: "0 0% 40%",
            muted: "0 0% 96%",
            border: "0 0% 90%",
        },
        fonts: {
            heading: "monospace",
            body: "sans-serif",
        },
        radius: "0px",
    },
}
